<template>
  <div class="navMenu">

   <template v-for="navMenu in navMenus">
        <!-- 最后一级菜单 -->
      <el-menu-item v-if="navMenu.childList.length==0"
                    :key="navMenu.menuId"
                    :index="navMenu.menuUri">
        <span slot="title">{{navMenu.menuName}}</span>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="navMenu.childList.length>0"
                   :key="navMenu.menuId" :index="navMenu.menuName">
        <template slot="title">
          <span> {{navMenu.menuName}}</span>
        </template>
        <!-- 递归 -->
          <!-- 修改三级菜单样式 -->
          <template v-for="subMenu in navMenu.childList">
              <el-menu-item  v-if="subMenu.childList.length==0"
                             :key="subMenu.menuId"
                             :index="subMenu.menuUri">
                <span slot="title">{{subMenu.menuName}}</span>
              </el-menu-item>
              <el-menu-item-group v-if="subMenu.childList.length>0" :key="subMenu.menuId" :title="subMenu.menuName">
                <template slot="title">{{subMenu.menuName}}</template>
                <el-menu-item :key="list.menuId" :index="list.menuUri" v-for="list in subMenu.childList">
                  {{list.menuName}}
                </el-menu-item>
              </el-menu-item-group>
          </template>
      </el-submenu>
    </template>

  </div>
</template>

<script>
  export default {
    name: 'HeaderMenu',
    props: ['navMenus'],
    data() {
      return {
      }
    },
    methods: {},
  }
</script>

<style>
  /* 水平样式 */
 .el-menu--horizontal>div>.el-submenu {
    float: left;
}
/* 一级菜单的样式 */
.el-menu--horizontal>div>.el-menu-item {
    float: left;
    height: 60px;
    line-height: 60px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
}
/* 解决下图1 下拉三角图标 */
.el-menu--horizontal>div>.el-submenu .el-submenu__icon-arrow {
    position: static;
    vertical-align: middle;
    margin-left: 8px;
    margin-top: -3px;
}
/* 解决下图2 无下拉菜单时 不对齐问题 */
.el-menu--horizontal>div>.el-submenu .el-submenu__title {
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #909399;
}


</style>



// WEBPACK FOOTER //
// src/components/Common/HeaderMenu.vue